import { render, staticRenderFns } from "./BuyCard.vue?vue&type=template&id=1a5c0507&scoped=true&"
import script from "./BuyCard.vue?vue&type=script&lang=js&"
export * from "./BuyCard.vue?vue&type=script&lang=js&"
import style0 from "./BuyCard.vue?vue&type=style&index=0&id=1a5c0507&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5c0507",
  null
  
)

export default component.exports